import {Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import {MessageService} from '../message.service';
import {RestApiService} from '../rest-api.service';
import {Router} from '@angular/router';
import {NgbModal ,NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Formatters} from 'angular-slickgrid';
import {CustomInputEditor} from '../custom-inputEditor';
import {NotifierService} from 'angular-notifier';
import {Subscription} from 'rxjs';
import {FormControl} from '@angular/forms';


@Component({
  selector: 'app-module-role',
  templateUrl: './module-role.component.html',
  styleUrls: ['./module-role.component.css']
})
export class ModuleRoleComponent implements OnInit, OnDestroy {
  displayed = true;
  selected: number;
  clientSelected: number;
  roleSelected: number;
  moduleSelected: number;
  show: boolean;
  totalData: number;
  selectedTitles: any[];
  respObject: any;
  clients = [];
  module = [];
  role = [];
  clientName: string;
  moduleName: string;
  roleName: string;
  notAdmin = true;

  displayData: any;

  add: boolean;
  del: boolean;
  edit: boolean;
  view: boolean;

  isError = false;
  errorMessage: string;

  private notifier: NotifierService;
  parents = [];
  parentSelected: string;
  private parentName: any;

  private clientId: number;
  private baseFlag: any;
  private cname: any;
  nextOffset: number;
  previousOffset: number;
  collectionSize: number;
  pageSize: number;
  paginationType: string;
  page_no: number;
  totalPage: number;
  private userAuth: Subscription;
  private adminAuth: Subscription;
  offset: number;
  parentArr = [];
  dataLoaded: boolean;
  showSearch = true;
  isLoading = false;
  searchData: FormControl = new FormControl();
  moduleSelecte: any;
  modules: any;
  name: string;
  showExportBtn = true;
  dataExcel = [];
  isExportDisable = false;
  @ViewChild('scarch_content') private scarch_content;
  private searchModalReference: NgbModalRef;

  constructor(private _rest: RestApiService, private messageService: MessageService, private route: Router,
              private modalService: NgbModal, notifier: NotifierService) {
    this.notifier = notifier;
    this.messageService.getCellChangeData().subscribe(item => {
      switch (item.type) {
        case 'change':
          // console.log('changed');
          if (!this.edit) {
            this.notifier.notify('error', 'You do not have edit permission');
          } else {

          }
          break;
        case 'delete':
          if (this.baseFlag) {
            if (!this.del) {
              this.notifier.notify('error', 'You do not have delete permission');
            } else {
              this.deleteItem(item);
            }
          } else {
            if (!this.messageService.del) {
              this.notifier.notify('error', 'You do not have delete permission');
            } else {
              this.deleteItem(item);
            }
          }
          break;
      }
    });
    this.messageService.getUserAuth().subscribe(details => {
      console.log(JSON.stringify(details));
      if (details.length > 0) {
        this.add = details[0].addFlag;
        this.del = details[0].deleteFlag;
        this.view = details[0].viewFlag;
        this.edit = details[0].editFlag;
      }
    });
    this.messageService.getSelectedItemData().subscribe(selectedTitles => {
      if (selectedTitles.length > 0) {
        this.show = true;
        this.selected = selectedTitles.length;
      } else {
        this.show = false;
      }
    });
  }

  deleteItem(item) {
    if (confirm('Are you sure?')) {
      this._rest.deleteMapModuleRole({id: item.id, user_id: this.messageService.getUserId()}).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.messageService.sendAfterDelete(item.id);
        } else {
          this.notifier.notify('error', this.respObject.errorMessage);
        }
      }, (err) => {
        this.notifier.notify('error', this.respObject.errorMessage);
      });
    }
  }

  ngOnInit() {
    this.dataLoaded=false;
    this.nextOffset = 0;
    this.previousOffset = 0;
    this.paginationType = 'next';
    this.page_no = 0;
    this.pageSize = this.messageService.pageSize;
    this.totalPage = 0;
    this.displayData = {
      pageName: 'Maintain Module Role Mapping',
      openModalButton: 'Module Role Map',
      searchModalButton: 'Search',

      breadcrumb: 'ModuleRoleMap',
      folderName: 'All Module Role Map',
      tabName: 'Module and Role Mapping',
      exportBtn: 'Export to excel'

    };
    const columnDefinitions = [
      {
        id: 'delete',
        field: 'id',
        excludeFromHeaderMenu: true,
        formatter: Formatters.deleteIcon,
        minWidth: 30,
        maxWidth: 30,
      },
      // {id: 'id', name: 'Id', field: 'id', sortable: true, filterable: true},
      {
        id: 'module', name: 'Module', field: 'module_name', sortable: true, filterable: true
      },
      {
        id: 'ROLE_NAME', name: 'Role', field: 'role_name', sortable: true, filterable: true
      },
      {
        id: 'client_name', name: 'Client ', field: 'client_name', sortable: true, filterable: true
      },
      {
        id: 'menu_name', name: 'Menu ', field: 'menu_name', sortable: true, filterable: true
      }
    ];
    this.messageService.setColumnDefinitions(columnDefinitions);
    if (this.messageService.clientId) {
      this.clientId = this.messageService.clientId;
      this.baseFlag = this.messageService.baseFlag;
      this.onPageLoad();
    } else {
      this.userAuth = this.messageService.getClientUserAuth().subscribe(auth => {
        this.view = auth[0].viewFlag;
        this.add = auth[0].addFlag;
        this.edit = auth[0].editFlag;
        this.del = auth[0].deleteFlag;
        this.clientId = auth[0].clientId;
        this.baseFlag = auth[0].baseFlag;
        this.onPageLoad();
      });
      this.adminAuth = this.messageService.getUserAuth().subscribe(details => {
        if (details.length > 0) {
          this.add = details[0].addFlag;
          this.del = details[0].deleteFlag;
          this.view = details[0].viewFlag;
          this.edit = details[0].editFlag;
          this.clientId = details[0].clientId;
          this.baseFlag = details[0].baseFlag;
          this.onPageLoad();
        }
      });
    }
  }

  onPageLoad() {
        if (this.baseFlag) {
          this.notAdmin = false;
          this._rest.getClient().subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
              this.respObject.clients.unshift({id: 0, name: 'Select Client'});
              this.clients = this.respObject.clients;
              this.clientSelected = 0;
            } else {
              this.notifier.notify('error', this.respObject.errorMessage);
            }
          }, (err) => {
            this.notifier.notify('error', this.messageService.SERVER_ERROR);
          });
        } else {
          // console.log('------------>' + this.clientId);
          this.clientSelected = this.clientId;
          this._rest.getModulesByClientId(this.clientSelected).subscribe((res1) => {
            this.respObject = res1;
            // console.log(JSON.stringify(this.respObject));
            if (this.respObject.success) {
              this.isError = false;
              this.respObject.modules.unshift({id: 0, name: 'Select Modules'});
              this.module = this.respObject.modules;
              this.moduleSelected = 0;
            } else {
              this.isError = true;
              this.errorMessage = this.respObject.errorMessage;
            }
          }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
          });
          this._rest.getRoleClientWise(this.clientSelected).subscribe((res1) => {
            this.respObject = res1;
            if (this.respObject.success) {
              this.isError = false;
              this.respObject.roles.unshift({id: 0, name: 'Select Role'});
              this.role = this.respObject.roles;
              this.roleSelected = 0;
            } else {
              this.isError = true;
              this.errorMessage = this.respObject.errorMessage;
            }
          }, (err) => {
            this.isError = true;
            this.errorMessage = this.messageService.SERVER_ERROR;
          });
        }
    this.getTableData();
  }

  changeRouting(path: string) {
    this.messageService.changeRouting(path);
  }

  onClientChange(selectedIndex) {
    this.clientName = this.clients[selectedIndex].name;
    this._rest.getModulesByClientId(this.clientSelected).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.isError = false;
        this.respObject.modules.unshift({id: 0, name: 'Select Modules'});
        this.module = this.respObject.modules;
        this.moduleSelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
    this._rest.getRoleClientWise(this.clientSelected).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.isError = false;
        this.respObject.roles.unshift({id: 0, name: 'Select Role'});
        this.role = this.respObject.roles;
        this.roleSelected = 0;
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }

  exportToExcel() {
    this.isExportDisable = true;

    // console.log("okkk" +this.clientId);
    this._rest.getAllModuleRoleMap(this.clientId).subscribe((res1) => {
        this.respObject = res1;
        if (this.respObject.success) {
            this.isExportDisable = false;

            this.dataExcel = this.respObject.details;
            // console.log('true' + JSON.stringify(this.dataExcel));
            this.messageService.exportAsExcelFile(this.dataExcel);
        } else {
            this.notifier.notify('error', this.respObject.errorMessage);
        }
    }, (err) => {
        this.notifier.notify('error', this.messageService.SERVER_ERROR);
    });
}

  openModal(content) {
    if (this.baseFlag) {
      if (!this.add) {
        this.notifier.notify('error', 'You do not have add permission');
      } else {
        this.isError = false;
        this.clientSelected = 0;
        this.roleSelected = 0;
        this.moduleSelected = 0;
        this.parentSelected = '0';
        this.modalService.open(content, {size: 'sm'}).result.then((result) => {
        }, (reason) => {
        });
      }
    } else {
      if (!this.messageService.add) {
        this.notifier.notify('error', 'You do not have add permission');
      } else {
        this.isError = false;
        this.roleSelected = 0;
        this.moduleSelected = 0;
        this.parentSelected = '0';
        this.modalService.open(content, {size: 'sm'}).result.then((result) => {
        }, (reason) => {

        });
      }
    }
  }


  searchModal(scarch_content)  {
    if (this.baseFlag) {
      if (!this.add) {
        this.notifier.notify('error', 'You do not have add permission');
      } else {
        this.isError = false;
        this.moduleSelecte = '';
        this.searchModalReference = this.modalService.open(this.scarch_content);
        this.searchModalReference.result.then((result) => {
        }, (reason) => {

        });
      }
    } else {
      if (!this.messageService.add) {
        this.notifier.notify('error', 'You do not have add permission');
      } else {
        this.isError = false;
        this.moduleSelecte = '';
        this.searchModalReference = this.modalService.open(this.scarch_content);
        this.searchModalReference.result.then((result) => {
        }, (reason) => {

        });
      }
    }
  }
  getDetails() {
    for (let i = 0; i < this.modules.length; i++) {
        if (this.modules[i].module_name === this.moduleSelecte) {
        
            this.name = this.modules[i].role_name;
        }
    }
}
search() {
  this._rest.searchAllModuleRoleMap( this.moduleSelecte, this.clientId).subscribe((res1) => {
    this.respObject = res1;
    this.isLoading = false;
    if (this.respObject.success) {
      this.modules = this.respObject.details;
      this.messageService.setTotalData(this.modules.length);
      this.messageService.setGridData(this.modules);
      this.searchModalReference.close();
    } else {
      this.notifier.notify('error', this.respObject.errorMessage);
    }
  }, (err) => {
    this.isLoading = false;
    this.notifier.notify('error', this.messageService.SERVER_ERROR);
  });
}

  onParentChange(selectedIndex: any) {
    this.parentName = this.parents[selectedIndex].name;
  }

  save() {
    const data = {
      client_id: this.clientSelected,
      module_id: this.moduleSelected,
      role_id: this.roleSelected,
      createdBy: this.messageService.getUserId()
    };
      this.parentArr = [];
      if (this.parentSelected === '-1') {
          for (let i = 2; i < this.parents.length; i++) {
              this.parentArr.push(this.parents[i].id);
          }
          data['menuId'] = this.parentArr;
      } else {
          this.parentArr.push(this.parentSelected);
          data['menuId'] = this.parentArr;
      }
    if (!this.messageService.isBlankField(data)) {
      this._rest.mapModuleRole(data).subscribe((res) => {
        this.respObject = res;
        if (this.respObject.success) {
          this.totalData = this.totalData + 1;
          this.messageService.setTotalData(this.totalData);
            this.isError = false;
            this.nextOffset = 0;
            this.page_no = 0;
            this.getTableData();
          if (this.baseFlag) {
            this.clientSelected = 0;
          }
          this.moduleSelected = 0;
          this.roleSelected = 0;
          this.parentSelected = '0';
        } else {
          this.isError = true;
          this.errorMessage = this.respObject.errorMessage;
        }
      }, (err) => {
        this.isError = true;
        this.errorMessage = err;
      });
    } else {
      this.isError = true;
      this.errorMessage = this.messageService.BLANK_ERROR_MESSAGE;
    }
  }

  isEmpty(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        return false;
      }
    }
    return true;
  }

  getTableData() {
    this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }

  getData(paginationObj) {
    const offset = paginationObj.offset;
    const paginationType = paginationObj.paginationType;
    this.dataLoaded = false;
    if (this.baseFlag) {
      if (!this.view) {
        this.notifier.notify('error', 'You do not have view permission');
      } else {
        this._rest.getModuleRolesMapping(offset, this.pageSize, paginationType).subscribe((res) => {
          this.respObject = res;
          this.executeResponse1(this.respObject, offset, paginationType);
        }, (err) => {
          this.notifier.notify('error', err);
        });
      }
    } else {
      if (!this.messageService.view) {
        this.notifier.notify('error', 'You do not have view permission');
      } else {
        this._rest.getModuleRolesMappingClientWise(this.clientId, offset, this.pageSize, paginationType).subscribe((res) => {
          this.respObject = res;
          this.executeResponse(this.respObject, offset, paginationType);
        }, (err) => {
          this.notifier.notify('error', err);
        });
      }
    }
  }

    executeResponse(respObject, offset, paginationType) {
        if (respObject.success) {
          this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.details.totalData[0].count;
                this.totalPage = respObject.details.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.details.dataObj)) {
                const data = respObject.details.dataObj;
                this.nextOffset = respObject.details.nextOffset;
                this.offset = respObject.details.nextOffset;
                this.previousOffset = respObject.details.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.details.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

    executeResponse1(respObject, offset, paginationType) {
        if (respObject.success) {
            this.dataLoaded = true;
            if (offset === 0) {
                this.totalData = respObject.moduleRoleMap.totalData[0].count;
                this.totalPage = respObject.moduleRoleMap.totalPage;
                if (this.totalPage === 0) {
                    this.totalPage = 1;
                }
            }
            if (!this.isEmpty(respObject.moduleRoleMap.dataObj)) {
                const data = respObject.moduleRoleMap.dataObj;
                this.nextOffset = respObject.moduleRoleMap.nextOffset;
                this.offset = respObject.moduleRoleMap.nextOffset;
                this.previousOffset = respObject.moduleRoleMap.previousOffset;
                this.messageService.setTotalData(this.totalData);
                this.messageService.setGridData(data);
                // ----------------------------------------------
                if (offset !== 0) {
                    const totalCount = this.totalData;
                    const divRes = totalCount / this.pageSize;
                    const remainder = totalCount % this.pageSize;
                    if (remainder === 0) {
                        this.totalPage = parseInt(String(divRes), 10);
                    } else {
                        this.totalPage = parseInt(String(divRes), 10) + 1;
                    }
                }
                // ------------------------------------------------
                if (paginationType === 'next') {
                    this.page_no = this.page_no + 1;
                } else if (paginationType === 'prev') {
                    this.page_no = this.page_no - 1;
                } else if (paginationType === '' && this.page_no === 0) {
                    this.page_no = this.page_no + 1;
                }
                if (this.totalData <= this.pageSize * this.page_no) {
                    this.nextOffset = 0;
                }
            } else if (this.isEmpty(respObject.moduleRoleMap.dataObj) && paginationType === 'next') {
                this.nextOffset = 0;
            } else if (this.isEmpty(respObject.moduleRoleMap.dataObj) && paginationType === 'prev') {
                this.previousOffset = 0;
            } else if (paginationType === '' && this.page_no === 0) {
                this.page_no = this.page_no + 1;
            }
        } else {
            this.notifier.notify('error', respObject.errorMessage);
        }
    }

  onModuleChange(selectedIndex: any) {
    this.moduleName = this.module[selectedIndex].name;
    this._rest.getMenuDtlsAllClientWise(this.clientSelected, this.moduleSelected).subscribe((res) => {
      this.respObject = res;
      if (this.respObject.success) {
        this.isError = false;
        this.respObject.details.unshift({id: 0, name: 'Select Menu'}, {id: -1, name: 'Select All'});
        this.parents = this.respObject.details;
          for (let i = 2; i < this.parents.length; i++) {
              this.parentArr.push(this.parents[i].id);
          }
        this.parentSelected = '0';
      } else {
        this.isError = true;
        this.errorMessage = this.respObject.errorMessage;
      }
    }, (err) => {
      this.isError = true;
      this.errorMessage = this.messageService.SERVER_ERROR;
    });
  }

  onRoleChange(selectedIndex: any) {
    this.roleName = this.role[selectedIndex].name;
  }

  onPageSizeChange(value: any) {
    this.page_no = 0;
    this.nextOffset = 0;
    this.pageSize = value;
    this.getData({'offset': this.nextOffset, 'paginationType': ''});
  }

  ngOnDestroy(): void {
    if (this.userAuth) {
      this.userAuth.unsubscribe();
    }
    if (this.adminAuth) {
      this.adminAuth.unsubscribe();
    }
  }
}
